// Central configuration for the backend API base URL
// Uses empty string in development to leverage devServer proxy and avoid CORS blocks
// export const API_BASE_URL = "http://3.90.61.4:5000";

export const API_BASE_URL = "https://api.socialbaazar.com";